import { render, staticRenderFns } from "./Describes.vue?vue&type=template&id=cbf0136c&scoped=true&"
import script from "./Describes.vue?vue&type=script&lang=js&"
export * from "./Describes.vue?vue&type=script&lang=js&"
import style0 from "./Describes.vue?vue&type=style&index=0&id=cbf0136c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf0136c",
  null
  
)

export default component.exports